import { ReactNode } from "react";

function MaterialContentCommentsLayout({
  testId,
  content,
  comments
}: {
  testId: string;
  content: ReactNode;
  comments: ReactNode;
}) {
  return (
    <div
      className="flex-1 flex flex-col lg:flex-row lg:justify-center min-w-0 min-h-0 overflow-y-auto lg:overflow-hidden bg-ciq-black-a3"
      data-testid={testId}
    >
      <div className="timeline-scroll-container px-4 lg:px-7 py-5 min-w-0 lg:flex-none lg:w-[416px] lg:overflow-y-auto lg:min-h-0">
        {content}
      </div>
      <div className="px-4 lg:px-6 py-5 lg:w-[300px] xl:w-[360px] lg:shrink-0 lg:sticky lg:top-0 lg:self-start lg:max-h-full">
        {comments}
      </div>
    </div>
  );
}

export default MaterialContentCommentsLayout;
